import React, { FC } from 'react';

import { Illustration, IllustrationProps } from '../IllustrationWrapper';

export const Suitcase: FC<IllustrationProps> = ({ size, color }) => (
  <Illustration size={size} color={color}>
    <path d="M66 20H50V16C50 12.69 47.31 10 44 10H36C32.69 10 30 12.69 30 16V20H14C8.49 20 4 24.49 4 30V60C4 65.51 8.49 70 14 70H66C71.51 70 76 65.51 76 60V30C76 24.49 71.51 20 66 20ZM34 16C34 14.9 34.9 14 36 14H44C45.1 14 46 14.9 46 16V20H34V16ZM72 60C72 63.31 69.31 66 66 66H14C10.69 66 8 63.31 8 60V30C8 26.69 10.69 24 14 24H53V32.17L48.59 36.58C48.21 36.96 48 37.46 48 37.99V50.99C48 52.09 48.9 52.99 50 52.99H60C61.1 52.99 62 52.09 62 50.99V37.99C62 37.46 61.79 36.95 61.41 36.58L57 32.17V24H66C69.31 24 72 26.69 72 30V60ZM55 35.83L58 38.83V49H52V38.83L55 35.83Z" />
  </Illustration>
);
